import { Navigate, useLocation } from "react-router-dom";
import { UserInfoModel } from "app/model/ua/user-info";
import { useAppSelector } from "app/store/hook";
import { BaseRouter } from "app/model/common/baseRouter";
import { brokerRouter } from "app/routers/brokerRouter";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";

export default function BrokerGuard({ children }: any) {
  const location = useLocation();
  const url = location.pathname;

  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const brokerMenuRouters: BaseRouter[] = brokerRouter;

  const checkIsAuthorizedBroker = (userInfo: UserInfoModel, routers: BaseRouter[], url: string) => {
    if (UserInfoUtil.hasRole(userInfo, AuthConstant.R002)) {
      const findBrokerRouter: BaseRouter | undefined = routers.find(router => url && url === router.path);
      if (findBrokerRouter) {
        return children;
      } else {
        return <Navigate to="/not-found" replace />;
      }
    }

    return <Navigate to="/not-permission" replace />;
  };

  return checkIsAuthorizedBroker(userInfo, brokerMenuRouters, url);
}